
import type {AppKitNetwork} from "@reown/appkit-common";
import {solana} from "@reown/appkit/networks";
import {SolanaAdapter} from "@reown/appkit-adapter-solana";
import {createAppKit} from "@reown/appkit/react";
import {DefaultSIWX, SolanaVerifier} from "@reown/appkit-siwx";
import {StorageInstance} from "@/utils/NotifyingLocalStorage.ts";
import type { SIWXConfig as SIWXConfigInterface } from '@reown/appkit-controllers';
import {ZenexAuthentication} from "@/ZenexAuthentication.ts";


const metadata = {
  //optional
  name: "ZNX HUB",
  description:
    "Zenex ecosystem with ZNX Play, ZNX Arena and ZNX Invest for diversified investment opportunities with guaranteed returns and exciting gameplay.",
  url: "https://zenexhub.com",
  icons: ["https://zenexhub.com/assets/460x460znx.png"], //TODO: Иконка Zenex hub
}

const projectId = import.meta.env.VITE_PROJECT_ID



const [networks, defaultNetwork] = ((env): [[AppKitNetwork, ...AppKitNetwork[]], AppKitNetwork] => {
  // if (env?.VITE_DEVNET_ENABLE && env.VITE_DEVNET_ENABLE == "yes") {
  //   return [[solanaDevnet], solanaDevnet]
  // }
  return [[solana], solana]
})(import.meta.env)

export const solanaAdapter = new SolanaAdapter({
  connectionSettings: {
    commitment: "confirmed",
  },
})

console.debug('default networks', defaultNetwork)
console.debug('env', import.meta.env)


class zSIWX extends DefaultSIWX implements SIWXConfigInterface {
  signOutOnDisconnect: true
  getRequired(): boolean {
      return true;
  }
}
const s = new zSIWX({
  verifiers: [
    new SolanaVerifier(),
  ],
  storage: StorageInstance,
})

export const appkit = createAppKit({
  adapters: [solanaAdapter /*, wagmiAdapter*/],
  projectId,
  networks: networks,
  defaultNetwork: defaultNetwork,
  metadata,
  themeMode: "dark",
  features: {
    analytics: true,
    socials: ["google", "discord", "x"],
    email: true,
  },
  siwx: new ZenexAuthentication({required:true}),
  enableNetworkSwitch:false,
  // enableMobileFullScreen: true,

})